import api from '../../../../api/client';

export const WEEKLY_OFF_OPTIONS = [
  { value: 'Select', label: '--Select--' },
  { value: 'Sunday', label: 'Sunday' },
  { value: 'Monday', label: 'Monday' },
  { value: 'Tuesday', label: 'Tuesday' },
  { value: 'Wednesday', label: 'Wednesday' },
  { value: 'Thursday', label: 'Thursday' },
  { value: 'Friday', label: 'Friday' },
  { value: 'Saturday', label: 'Saturday' },
];

export const SECOND_WEEKLY_OFF_OPTIONS = [
  { value: 'Select', label: '--Select--' },
  { value: 'None', label: 'None' },
  { value: '1st & 3rd Saturday', label: '1st & 3rd Saturday' },
  { value: '2nd & 4th Saturday', label: '2nd & 4th Saturday' },
  { value: '1st Saturday', label: '1st Saturday' },
  { value: '2nd Saturday', label: '2nd Saturday' },
  { value: '3rd Saturday', label: '3rd Saturday' },
  { value: '4th Saturday', label: '4th Saturday' },
  { value: 'All Saturdays', label: 'All Saturdays' },
];

export const groupMasterApi = {
  getAll: async (filters = {}) => {
    const params = {};
    if (filters.name && filters.name.trim()) {
      params.name = filters.name.trim();
    }
    if (filters.weeklyOff && filters.weeklyOff !== 'Select' && filters.weeklyOff !== 'All') {
      params.weekly_off = filters.weeklyOff;
    }
    if (filters.secondWeeklyOff && filters.secondWeeklyOff !== 'Select' && filters.secondWeeklyOff !== 'All') {
      params.second_weekly_off = filters.secondWeeklyOff;
    }
    if (filters.status) {
      params.status_filter = filters.status;
    }
    if (filters.page) {
      params.page = filters.page;
    }
    if (filters.pageSize) {
      params.page_size = filters.pageSize;
    }

    try {
      const res = await api.get('/payroll/employee-group', { params });
      return res.data;
    } catch (err) {
      console.error('Failed to fetch employee groups from api:', err);
      throw err;
    }
  },

  getById: async (id) => {
    try {
      const res = await api.get(`/payroll/employee-group/${id}`);
      const item = res.data;
      return {
        id: item.id,
        name: item.name,
        weeklyOff: item.weekly_off,
        secondWeeklyOff: item.second_weekly_off,
        status: item.status,
      };
    } catch (err) {
      console.error(`Failed to fetch employee group ${id}:`, err);
      throw err;
    }
  },

  create: async (data) => {
    try {
      const payload = {
        name: data.name,
        weekly_off: data.weeklyOff || data.weekly_off || 'Sunday',
        second_weekly_off: (data.secondWeeklyOff === 'Select' || !data.secondWeeklyOff) ? 'None' : data.secondWeeklyOff,
      };
      const res = await api.post('/payroll/employee-group', payload);
      return res.data;
    } catch (err) {
      console.error('Failed to create employee group:', err);
      throw err;
    }
  },

  update: async (id, data) => {
    try {
      const payload = {
        name: data.name,
        weekly_off: data.weeklyOff || data.weekly_off,
        second_weekly_off: (data.secondWeeklyOff === 'Select' || !data.secondWeeklyOff) ? 'None' : data.secondWeeklyOff,
      };
      const res = await api.put(`/payroll/employee-group/${id}`, payload);
      return res.data;
    } catch (err) {
      console.error(`Failed to update employee group ${id}:`, err);
      throw err;
    }
  },

  archive: async (id, archiveVal = null) => {
    try {
      const params = {};
      if (archiveVal !== null) {
        params.archive = archiveVal;
      }
      const res = await api.patch(`/payroll/employee-group/${id}/archive`, null, { params });
      return res.data;
    } catch (err) {
      console.error(`Failed to archive employee group ${id}:`, err);
      throw err;
    }
  },

  delete: async (id) => {
    try {
      const res = await api.delete(`/payroll/employee-group/${id}`);
      return res.data;
    } catch (err) {
      console.error(`Failed to delete employee group ${id}:`, err);
      throw err;
    }
  },
};
